// import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import MainBody from './components/MainBody'
import Contact from './components/Contact';
import About from './components/About';
import Projects from './components/Projects';
import {createBrowserRouter,RouterProvider} from 'react-router-dom'



   const Router= createBrowserRouter([
    {
       path: '/',
    element: (
      <div className="App">
        <Navbar />
        <MainBody />
        <Footer />
      </div>
    )
  },
  {
    path: '/home',
    element: (
      <div className="App">
        <Navbar />
        <MainBody />
        <Footer />
      </div>
    )
  },
    {
      path:'/contact',
      element:(
        <div className='App'>
          <Navbar/>
          <Contact/>
        </div>
      )
    },
    {
      path:'/About',
      element:(
        <div className='App'>
          <Navbar/>
          <About/>
        </div>
      )
    },
    {
      path:'/project',
      element:(
        <div className='App'>
          <Navbar/>
          <Projects/>
        </div>
      )
    },
   
  ])
function App() {
  return (
    <RouterProvider router={Router}/>
  );
}

export default App;
